import { render, staticRenderFns } from "./p02.vue?vue&type=template&id=130053fd&scoped=true&"
import script from "./p02.vue?vue&type=script&lang=js&"
export * from "./p02.vue?vue&type=script&lang=js&"
import style0 from "./p02.vue?vue&type=style&index=0&id=130053fd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130053fd",
  null
  
)

export default component.exports